import ReactPlayer from 'react-player';
import AppCard from '../../../components/appCard';


export default function Tutoriais() {

  return (
    <AppCard className='grid gap-4'>
      <div className="w-full text-xl">
        <h4><b>Área de Tutoriais</b></h4>
      </div>
      <div className='grid grid-cols-1 lg:grid-cols-2 justify-around w-full' >
        <div className='p-2'>
          <div className='text-green-50 bg-sky-900 dark:text-sky-900 dark:bg-green-50 
          p-5 text-xl rounded-lg justify-between grid grid-cols-1 gap-3'>
            <h5><b>Configurações da Plataforma</b></h5>
            <ReactPlayer width="100%" height="315px"
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    autoplay: 0,
                    controls: 1,
                    color: 'white',
                    hl: 'pt',
                    rel: 0,
                    showinfo: 0,
                  }
                }
              }}
              url="https://youtu.be/vffniqvMgxU?si=nISu-wZ9SCJNlIf5">
            </ReactPlayer>
          </div>
        </div>
        <div className='p-2'>
          <div className='text-green-50 bg-sky-900 dark:text-sky-900 dark:bg-green-50 
          p-5 text-xl rounded-lg justify-between grid grid-cols-1 gap-3'>
            <h5><b>Inadimplências</b></h5>
            <ReactPlayer width="100%" height="315px"
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    autoplay: 0,
                    controls: 1,
                    color: 'white',
                    hl: 'pt',
                    rel: 0,
                    showinfo: 0,
                  }
                }
              }}
              url="https://youtu.be/Q78CenNdGKQ">
            </ReactPlayer>
          </div>
        </div>
        <div className='p-2'>
          <div className='text-green-50 bg-sky-900 dark:text-sky-900 dark:bg-green-50 
          p-5 text-xl rounded-lg justify-between grid grid-cols-1 gap-3'>
            <h5><b>Relatórios</b></h5>
            <ReactPlayer width="100%" height="315px"
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    autoplay: 0,
                    controls: 1,
                    color: 'white',
                    hl: 'pt',
                    rel: 0,
                    showinfo: 0,
                  }
                }
              }}
              url="https://youtu.be/mQwRyf1xVOM">
            </ReactPlayer>
          </div>
        </div>
        <div className='p-2'>
          <div className='text-green-50 bg-sky-900 dark:text-sky-900 dark:bg-green-50 
          p-5 text-xl rounded-lg justify-between grid grid-cols-1 gap-3'>
            <h5><b>Boleto Inteligente</b></h5>
            <ReactPlayer width="100%" height="315px"
              controls={true}
              config={{
                youtube: {
                  playerVars: {
                    autoplay: 0,
                    controls: 1,
                    color: 'white',
                    hl: 'pt',
                    rel: 0,
                    showinfo: 0,
                  }
                }
              }}
              url="https://youtu.be/OOZfQx7Wcnw">
            </ReactPlayer>
          </div>
        </div>
        {/* <div className='text-green-900 w-full lg:w-5/12 card bg-teal-100 justify-center'>
                    <h5><b>Sistema de Cargas</b></h5>
                    <iframe width="100%" height="315"
                    src="https://www.youtube.com/embed/It4_3w59VMA">
                    </iframe>
                </div> */}
      </div>
    </AppCard>

  )
}
